import { QueryEntity } from '@datorama/akita';
import { AttachmentEntity, AttachmentsState, AttachmentsStore } from './attachments.store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EAttachmentsCategory } from '../constants/attachments-category.enum';
import { Attachment } from '../models/attachment.model';
import { asArray, isNull } from '../../../search/musimap-filters/musimap-common/musimap-common.utils';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsQuery extends QueryEntity<AttachmentsState, AttachmentEntity> {
  constructor(protected store: AttachmentsStore) {
    super(store);
  }

  getProjectAttachmentsByCategory(
    projectId: number,
    categories: EAttachmentsCategory | EAttachmentsCategory[] | null = null
  ): Observable<Attachment[]> {
    const searchCategories =
      isNull(categories) ||
      categories === EAttachmentsCategory.ALL ||
      asArray(categories).includes(EAttachmentsCategory.ALL)
        ? EAttachmentsCategory.ALL
        : asArray(categories);

    return this.selectEntity(projectId, ({ attachments }) =>
      attachments.filter(
        file => searchCategories === EAttachmentsCategory.ALL || asArray(searchCategories).includes(file.category)
      )
    );
  }
}
